import { useContext } from "react";
import { AppContext } from "../../../app/AppContext.tsx";

export const useInsightsAgentService = () => {
  const { insightsAgentService } = useContext(AppContext);
  if (!insightsAgentService)
    throw new Error("InsightsAgentService not initialized");
  return insightsAgentService;
};
